import { formatters } from '@utils/formattersV2';
import { HighlightsText } from '../../../../domain/text/highlights-text';
import { VisitMetrics } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { nanoid } from 'nanoid';

type VisitMetricsInput = Pick<
  VisitMetrics,
  'uniqueUsers' | 'projectedVisits' | 'incrementalLift' | 'incrementalVisits'
>;

export const visitHighlightsText: HighlightsText<VisitMetricsInput> = props => {
  const usersString = formatters.users(props.metrics.uniqueUsers, {
    full: true,
  });
  const projectedVisitsString = formatters.visits(
    props.metrics.projectedVisits,
    { full: true }
  );
  const incrementalVisitsString = formatters.visits(
    props.metrics.incrementalVisits,
    { full: true }
  );

  const incrementalLiftString = formatters.lift(props.metrics.incrementalLift, {
    decimals: 1,
  });

  const incrementalLiftText =
    props.metrics.incrementalLift && props.metrics.incrementalLift > 0
      ? [
          'had ',
          props.formatValues.incrementalLift(incrementalLiftString, nanoid()),
          ' more visits',
        ]
      : ['saw no increase in visitation'];

  return [
    'The ',
    props.campaignName,
    ' campaign reached ',
    props.formatValues.uniqueUsers(usersString, nanoid()),
    ' users who visited ',
    props.formatValues.projectedVisits(projectedVisitsString, nanoid()),
    ' times after being exposed. Compared to the control, the matched exposed users ',
    ...incrementalLiftText,
    ' which is indicated by the Incremental Lift. The campaign generated ',
    props.formatValues.incrementalVisits(incrementalVisitsString, nanoid()),
    ' Incremental Visits that would not have occurred without exposure to this campaign.',
  ];
};
